function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "currentColor"
}, React.createElement("path", {
  d: "M19.32 5.04l-8.485 8.485 1.414 1.414 8.485-8.485z"
}), React.createElement("path", {
  d: "M3.76 6.45l8.485 8.485 1.415-1.414-8.486-8.486zM4 17h16v2H4z"
}));

var SvgDownload = function SvgDownload(props) {
  return React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    width: 24
  }, props), _ref);
};

export default SvgDownload;